module.exports = __webpack_public_path__ + "static/media/kyc-mode.6eefafbf.png";